<template>
  <div id="small-container" class="d-flex flex-column h-100 px-1">
    <div id="top-spacer"></div>
    <div class="d-flex align-items-center justify-content-between flex-column flex-grow-1">
      <ul>
        <li v-for="link in links" v-if="shouldDisplay(link)" :key="link.index" class="link mb-3">
          <SidebarIcon v-bind:link="link" />
        </li>
      </ul>
      <div class="icon-container d-flex justify-content-center align-items-center" @click="handleLogout">
        <b-icon icon="door-open" class="icon" title="logout"></b-icon>
      </div>
    </div>
    <div id="bottom-spacer"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SidebarIcon from './SidebarIcon'

export default {
  name: 'SmallSidebar',
  props: ['links', 'isAdmin'],
  components: {
    SidebarIcon
  },
  methods: {
    ...mapActions(['doLogout']),
    shouldDisplay: function (link) {
      if (!link.mobile) return false
      switch (link.access) {
        case 'all':
          return true
        case 'admin':
          return this.isAdmin
        case 'client':
          return !this.isAdmin
        default:
          return true
      }
    },
    handleLogout: function () {
      this.doLogout()
      this.$router.push('/admin/login')
    }
  }
}
</script>

<style scoped>
#top-spacer {
  height: 44px;
  width: 100%;
}

#bottom-spacer {
  height: 128px;
  width: 100%;
}

#small-container {
  background-color: #2d3363;
}

ul {
  list-style-type: none;
}

.link {
  color: #2D3363;
  text-decoration: none;
}

.icon-container {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  border: 2px solid white;
  position: relative;
  cursor: pointer;
}

.icon {
  width: 70%;
  height: 70%;
  color: white;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/app/components/Layout/Sidebar/SmallSidebar.vue?ca6b607e